import { useCallback, useEffect, useState } from 'react'
import { Slider, Row, Col } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import InputNumberDiwa from './InputNumberDiwa'

function PriceSlider(props) {
  const [min, setMin] = useState(props.minPrice)
  const [max, setMax] = useState(props.maxPrice)

  const onChange = useCallback(values => {
    setMin(values[0])
    setMax(values[1])
  }, [])

  useEffect(() => {
    setMin(props.minPrice)
    setMax(props.maxPrice)
  }, [props.maxPrice, props.minPrice])

  const closeAndFilter = useCallback(() => {
    props.onClose(min, max)
  }, [min, max, props])

  return (
    <div className='atelier-slider'>
      <Row>
        <Col span={12}>
          <InputNumberDiwa
            min={props.minPrice}
            max={props.maxPrice}
            step={10}
            controls={false}
            value={min}
            onChange={setMin}
            size='small'
            className='w-60-p'
          />
        </Col>
        <Col span={12}>
          <InputNumberDiwa
            min={props.minPrice}
            max={props.maxPrice}
            step={10}
            controls={false}
            value={max}
            onChange={setMax}
            size='small'
            className='w-60-p'
          />
        </Col>
      </Row>
      <Row>
        <Col span={18}>
          <Slider range step={10} min={props.minPrice} max={props.maxPrice} onChange={onChange} value={[min, max]} />
        </Col>
        <Col span={6}>
          <CheckOutlined className='filter-drawer-check-icon' onClick={closeAndFilter} />
        </Col>
      </Row>
    </div>
  )
}

export default PriceSlider
